import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileTextFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M25 28H7v-2H5v2a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-2h-2zm1.42-19.57-5.83-5.84A2 2 0 0 0 19.18 2H7a2 2 0 0 0-2 2v9h2V4h11v5a2 2 0 0 0 2 2h5v2h2V9.84a2 2 0 0 0-.58-1.41M28 13H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2m-15.9 5h-1.31v4.12h-1.4V18H8.08v-1.17h4zm4.9 4.16-1-1.68-1 1.68h-1.62l1.78-2.71-1.68-2.62h1.58l.94 1.68.94-1.68h1.68l-1.68 2.71 1.77 2.62zM23.92 18h-1.31v4.12h-1.4V18H19.9v-1.17h4z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFileTextFilledSVG);
ForwardRef.displayName = "IconFileTextFilled";
export { ForwardRef as IconFileTextFilled };
